<div class="search-wrapper" [ngClass]="getClasses()">
  <div class="search">
    <!-- <mat-icon class="search-icon">search</mat-icon> -->
    <dp-svg [src]="SvgMap.search" class="mr-8"></dp-svg>
    <input matInput type="search" [disabled]="searchDisable" [placeholder]="placeholder" [ngModel]="value" (ngModelChange)="onModelChange($event, value)"
      (keyup)="onKeyUp($event)" />

    <button color="primary" *ngIf="value" mat-icon-button aria-label="Clear"
      (click)="clear()">
      <mat-icon class="no-hover-effect">close</mat-icon>
    </button>

    <span mat-icon-button *ngIf='showFilter' class='filter-popup' [class]="!disableFilter ? '' : 'filter-icon'" (click)="openFilterPopup()" [tooltip]="!disableFilter ? 'Open Filters' : ''" placement="bottom">
      <dp-svg [src]="SvgMap.filter" w="18" [color]="'var(--primary-brand-main)'"></dp-svg>
      <div class='circle' *ngIf='filterCount'>{{filterCount}}</div>
    </span>
  </div>
</div>
